import { Admin, Resource, CustomRoutes, defaultTheme } from "react-admin";
import { Route } from "react-router-dom";

import dataProvider from "./dataProvider";
import authProvider from "./authProvider";
import i18nProvider from "./i18nProvider";

import BusinessIcon from "@mui/icons-material/Business";
import PeopleIcon from "@mui/icons-material/People";
import InventoryIcon from "@mui/icons-material/Inventory";
import AssignmentIcon from "@mui/icons-material/Assignment";
import EventIcon from "@mui/icons-material/Event";

import {
  ExternalsOrderCollect,
  ExternalsClientInventoryCreate,
  ExternalsProviderInventoryCreate,
  ExternalsOutletInventoryCreate,
  ExternalsOutletCollect,
} from "./externals";

import { ClientList, ClientCreate, ClientEdit } from "./clients";
import { ProviderList, ProviderEdit, ProviderCreate } from "./providers";
import {
  ClientInventoryList,
  ClientInventoryCreate,
  ClientInventoryDetails,
} from "./client-inventory";
import { OrderList, OrderCreate, OrderEdit } from "./orders";

import { MainLayout } from "./layout/Layout";
import {
  ProviderInventoryCreate,
  ProviderInventoryDetails,
  ProviderInventoryList,
} from "./provider-inventory";
import { OutletCreate, OutletEdit, OutletList } from "./outlets";
import {
  OutletInventoryCreate,
  OutletInventoryDetails,
  OutletInventoryList,
} from "./outlet-inventory";
import { AppointmentCreate, AppointmentList } from "./appointments";
import { Dashboard } from "./dashboard";
import { NotFoundPage } from "./NotFoundPage";
import { ExternalLayout } from "./layout/ExternalLayout";

function App() {
  return (
    <Admin
      dashboard={Dashboard}
      dataProvider={dataProvider}
      authProvider={authProvider}
      i18nProvider={i18nProvider}
      layout={MainLayout}
      theme={defaultTheme}
    >
      {/* Public route, bypasses authProvider.checkAuth */}
      <CustomRoutes noLayout>
        <Route path="/externals/*" element={<ExternalLayout />}>
          <Route
            path="client-inventory/create"
            element={<ExternalsClientInventoryCreate />}
          />
          <Route path="order/validate" element={<ExternalsOrderCollect />} />
          <Route
            path="appointment/validate"
            element={<ExternalsOutletCollect />}
          />
          <Route
            path="provider-inventory/create"
            element={<ExternalsProviderInventoryCreate />}
          />
          <Route
            path="outlet-inventory/create"
            element={<ExternalsOutletInventoryCreate />}
          />

          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </CustomRoutes>
      {/* All your protected resources */}
      <CustomRoutes>
        <Route
          path="/client-inventory/details/:id"
          element={<ClientInventoryDetails />}
        />
        <Route
          path="/provider-inventory/details/:id"
          element={<ProviderInventoryDetails />}
        />
        <Route
          path="/outlet-inventory/details/:id"
          element={<OutletInventoryDetails />}
        />
        <Route path="*" element={<NotFoundPage />} />
      </CustomRoutes>
      <Resource
        name="orders"
        icon={AssignmentIcon}
        options={{ label: "Bons de Commande" }}
        list={OrderList}
        create={OrderCreate}
        edit={OrderEdit}
      />
      <Resource
        name="clients"
        options={{ label: "Clients" }}
        icon={PeopleIcon}
        list={ClientList}
        edit={ClientEdit}
        create={ClientCreate}
      />
      <Resource
        name="clientInventory"
        icon={InventoryIcon}
        options={{ label: "Inventaire clients" }}
        list={ClientInventoryList}
        create={ClientInventoryCreate}
      />
      <Resource
        name="providers"
        options={{ label: "Prestataires" }}
        icon={BusinessIcon}
        list={ProviderList}
        edit={ProviderEdit}
        create={ProviderCreate}
      />
      <Resource
        name="providerInventory"
        icon={InventoryIcon}
        options={{ label: "Inventaire prestataires" }}
        list={ProviderInventoryList}
        create={ProviderInventoryCreate}
      />
      <Resource
        name="outlets"
        options={{ label: "Exutoires" }}
        icon={BusinessIcon}
        list={OutletList}
        edit={OutletEdit}
        create={OutletCreate}
      />
      <Resource
        name="outletInventory"
        icon={InventoryIcon}
        options={{ label: "Inventaire exutoires" }}
        list={OutletInventoryList}
        create={OutletInventoryCreate}
      />
      <Resource
        name="appointments"
        icon={EventIcon}
        options={{ label: "Calendrier RDV" }}
        list={AppointmentList}
        create={AppointmentCreate}
      />
    </Admin>
  );
}

export default App;
